export default __webpack_public_path__ + "static/home_collinsia_heterophylla-4ecda890b6343e78272c5aa57560521f.jpg";